export default "__VITE_ASSET__c5611d2a__"